__turbopack_context__.v({
  "className": "dosis_5cd22955-module__3XiONW__className",
});
